import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

export default function BrStepLabel(props) {
  const { label, active, nestingLevel, stepNumber, totalSteps, hasSubSteps } = props;
  const stepNameClasses = cn(
    'step-label-container',
    { 'step-label-active': active },
    { 'step-label-root-level': nestingLevel === 1 },
    { 'step-label-substep-level': nestingLevel > 1 },
    { 'step-label-container-first': stepNumber === 1 },
    { 'step-label-container-last': stepNumber === totalSteps },
    { 'step-label-container-with-substeps': hasSubSteps },
  );
  const stepNumberClasses = cn('stepnum', { 'step-number-active': active });
  return stepNumber ? (
    <div className={stepNameClasses}>
      <div className={stepNumberClasses}>{stepNumber}</div>
      {label}
    </div>
  ) : (
    <div className={stepNameClasses}>{label}</div>
  );
}

BrStepLabel.propTypes = {
  label: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  nestingLevel: PropTypes.oneOf([1, 2]).isRequired,
  stepNumber: PropTypes.number,
  totalSteps: PropTypes.number.isRequired,
  hasSubSteps: PropTypes.bool.isRequired,
};
